import { IncidentView } from './incident-view';
import { IncidentType } from './incident-type';

export class IncidentDetailLinkOutputData {
  id: number;
  type: IncidentType;
  view: IncidentView;
}
